import {
    SkyNetTableTab,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    RegionSecondLevel,
    RegionFirstLevel,
    PickupFeeType,
} from 'app/enums/label.enums'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    RateCardsTabs,
} from 'app/enums/domain.enums'
import requests from 'app/requests/RateCard/RateCard.requests'
import {
    LogisticsCostsItem,
} from './LogisticsCosts.types'

const getAvailabilityOrCost = (availability: PickupFeeType, cost: number) => {
    if (availability === PickupFeeType.CHARGE) {
        return cost
    }
    if (availability === PickupFeeType.FREE) {
        return '-'
    }
    return 'Not Available'
}

const config: SkyNetTableTab<keyof LogisticsCostsItem> = {
    name: 'Logistic Costs',
    url: RateCardsTabs.LogisticsCosts,
    customUrl: requests.logisticsCostsFilterRequest().url,
    fields: [
        {
            name: 'regionFirstLevel',
            labelKey: 'Country.regionFirstLevel',
            componentName: 'EnumValue',
            allowedValuesEnum: RegionFirstLevel,
            filterField: 'regionFirstLevel',
            filterType: FilterType.Array,
            width: '20%',
        },
        {
            name: 'regionSecondLevel',
            labelKey: 'Country.regionSecondLevel',
            componentName: 'EnumValue',
            allowedValuesEnum: RegionSecondLevel,
        },
        {
            name: 'countries',
            labelKey: 'LogisticsCostsRateCard.countries',
            mapCellProps: ({
                countries,
            }: LogisticsCostsItem) => {
                return {
                    children: countries?.join(', '),
                }
            },
            width: '30%',
            sorting: false,
        },
        {
            name: 'originCostPickUpCustomerAvailability',
            labelKey: 'LogisticsCostsRateCard.originCostByCustomer',
            mapCellProps: ({
                originCostPickUpCustomerAvailability,
                originCostPickUpCustomer,
            }: LogisticsCostsItem) => {
                return {
                    children: getAvailabilityOrCost(originCostPickUpCustomerAvailability,
                        originCostPickUpCustomer),
                }
            },
            sorting: false,
            alignTextRight: true,
        },
        {
            name: 'originCostLtlAvailability',
            labelKey: 'LogisticsCostsRateCard.originCostLtl',
            mapCellProps: ({
                originCostLtlAvailability,
                originCostLtl,
            }: LogisticsCostsItem) => {
                return {
                    children: getAvailabilityOrCost(originCostLtlAvailability,
                        originCostLtl),
                }
            },
            sorting: false,
            alignTextRight: true,
        },
        {
            name: 'originCostFtlAvailability',
            labelKey: 'LogisticsCostsRateCard.originCostFtl',
            mapCellProps: ({
                originCostFtlAvailability,
                originCostFtl,
            }: LogisticsCostsItem) => {
                return {
                    children: getAvailabilityOrCost(originCostFtlAvailability,
                        originCostFtl),
                }
            },
            sorting: false,
            alignTextRight: true,
        },
        {
            name: 'reverseCostAvailability',
            labelKey: 'LogisticsCostsRateCard.reverseConst',
            mapCellProps: ({
                reverseCostAvailability,
                reverseCost,
            }: LogisticsCostsItem) => {
                return {
                    children: getAvailabilityOrCost(reverseCostAvailability,
                        reverseCost),
                }
            },
            sorting: false,
            alignTextRight: true,
        },
        {
            name: 'collectionLtlAvailability',
            labelKey: 'LogisticsCostsRateCard.collectionBySkyCellLTL',
            mapCellProps: ({
                collectionLtlAvailability,
                collectionLtl,
            }: LogisticsCostsItem) => {
                return {
                    children: getAvailabilityOrCost(collectionLtlAvailability,
                        collectionLtl),
                }
            },
            sorting: false,
            alignTextRight: true,
        },
        {
            name: 'collectionFtlAvailability',
            labelKey: 'LogisticsCostsRateCard.collectionBySkyCellFTL',
            mapCellProps: ({
                collectionFtlAvailability,
                collectionFtl,
            }: LogisticsCostsItem) => {
                return {
                    children: getAvailabilityOrCost(collectionFtlAvailability,
                        collectionFtl),
                }
            },
            sorting: false,
            alignTextRight: true,
        },
    ],
}

export default config
